var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/PerspectiveArchivesList/PerspectiveArchivesListInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/PerspectiveArchivesList/PerspectiveArchivesListInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("archive", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "<li data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") % 4) * 50, env.opts.autoescape);
output += "\">\n        ";
if(!runtime.memberLookup((t_7),"link")) {
output += "\n            <div class=\"PerspectiveArchivesListInner-archive\">\n        ";
;
}
else {
output += "\n            <a class=\"PerspectiveArchivesListInner-archive\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"link"), env.opts.autoescape);
output += "\">\n        ";
;
}
output += "\n            <div class=\"PerspectiveArchivesListInner-archiveImg\">\n                ";
if(runtime.memberLookup((t_7),"cover")) {
output += "<img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"cover")),"w440_url"), env.opts.autoescape);
output += "\"\n                  srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"cover")),"w680_url"), env.opts.autoescape);
output += " 2x\"\n                  alt=\"\">\n                ";
;
}
output += "</div>\n            <div class=\"PerspectiveArchivesListInner-archiveInfo\">\n                <div class=\"PerspectiveArchivesListInner-archiveDetail\">\n                    ";
output += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_7),"date"),"%B"), env.opts.autoescape);
output += "\n                    ";
if(!runtime.memberLookup((t_7),"dateEnd") || env.getFilter("datetime").call(context, runtime.memberLookup((t_7),"date"),"%B %Y") == env.getFilter("datetime").call(context, runtime.memberLookup((t_7),"dateEnd"),"%B %Y") || env.getFilter("datetime").call(context, runtime.memberLookup((t_7),"date"),"%Y") != env.getFilter("datetime").call(context, runtime.memberLookup((t_7),"dateEnd"),"%Y")) {
output += "\n                        ";
output += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_7),"date"),"%Y"), env.opts.autoescape);
output += "\n                    ";
;
}
output += "\n                    ";
if(runtime.memberLookup((t_7),"dateEnd") && env.getFilter("datetime").call(context, runtime.memberLookup((t_7),"date"),"%B %Y") != env.getFilter("datetime").call(context, runtime.memberLookup((t_7),"dateEnd"),"%B %Y")) {
output += "\n                        - <nobr>";
output += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_7),"dateEnd"),"%B %Y"), env.opts.autoescape);
output += "</nobr>\n                    ";
;
}
output += "\n                </div>\n            </div>\n        ";
if(runtime.memberLookup((t_7),"link")) {
output += "\n            </a>\n        ";
;
}
else {
output += "\n            </div>\n        ";
;
}
output += "\n    </li>\n";
;
}
}
frame = frame.pop();
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/PerspectiveArchivesList/PerspectiveArchivesListInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PerspectiveArchivesList/PerspectiveArchivesListInner.jinja
// module id = 122
// module chunks = 0